import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Injectable } from '@angular/core';
import { environment } from "src/environments/environment";
import { IClient } from '../../../shared/interfaces/IClient';


@Injectable({
  providedIn: 'root'
})

@Component({
  selector: 'app-purchase-thanks-page',
  templateUrl: './purchase-thanks-page.component.html',
  styleUrls: ['./purchase-thanks-page.component.scss']
})
export class PurchaseThanksPageComponent implements OnInit {
  private apiUrl = environment.apiUrl;
  user: IClient;
  
  // Propiedades para manejar el tipo de transacción
  isSubscription: boolean = false;
  paymentMethod: string = '';
  planId: string = '';
  subscriptionId: string = '';
  
  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    // Leer los query parameters para determinar el tipo de transacción
    this.route.queryParams.subscribe(params => {
      // Detectar suscripción por el parámetro 'type' o por 'preapproval_id' (que viene de Mercado Pago)
      this.isSubscription = params['type'] === 'subscription' || !!params['preapproval_id'];
      this.paymentMethod = params['method'] || (params['preapproval_id'] ? 'mercado_pago' : '');
      this.planId = params['planId'] || '';
      this.subscriptionId = params['subscriptionId'] || params['preapproval_id'] || '';
      
      console.log('Parámetros de la página de agradecimiento:', {
        isSubscription: this.isSubscription,
        paymentMethod: this.paymentMethod,
        planId: this.planId,
        subscriptionId: this.subscriptionId,
        preapproval_id: params['preapproval_id']
      });

      // Log específico para debugging
      if (this.isSubscription) {
        console.log('✅ Mostrando página de agradecimiento para SUSCRIPCIÓN');
        if (params['preapproval_id']) {
          console.log('🔗 Detección por preapproval_id de Mercado Pago');
        }
      } else {
        console.log('🛒 Mostrando página de agradecimiento para COMPRA');
      }
    });
  }

  // Método para obtener el título dinámico
  getPageTitle(): string {
    return this.isSubscription ? '¡Gracias por suscribirte!' : '¡Gracias por su compra!';
  }

  // Método para verificar si se debe mostrar información de Mercado Pago
  shouldShowMercadoPagoInfo(): boolean {
    return this.isSubscription && this.paymentMethod === 'mercado_pago';
  }

  volver(): void {
    this.router.navigateByUrl("/clients");
  }

}
